export default class MobileMenus {
    breakPoint = 1200;

    subMenusContainer = document.querySelector('#sub-menus');

    hasChildrenItems = document.querySelectorAll(
        '.site-header-primary-menu .menu-item-has-children'
    );

    displaySubMenu = false;

    activeElement = {};

    constructor() {
        this.hasChildrenItems.forEach((button) => {
            button.addEventListener('mouseover', () => {
                this.openDesktopSubMenu(button);
            });
            button.addEventListener('mouseout', () => {
                this.removeSubMenu();
            });
        });

        this.subMenusContainer.addEventListener('mouseover', () => {
            this.displaySubMenu = true;
        });

        this.subMenusContainer.addEventListener('mouseout', () => {
            this.removeSubMenu();
        });
    }

    removeSubMenu = () => {
        this.displaySubMenu = false;
        setTimeout(() => {
            if (window.innerWidth >= this.breakPoint && !this.displaySubMenu) {
                this.subMenusContainer.innerHTML = '';
                this.activeElement.classList.remove('open');
            }
        }, 200);
    };

    openDesktopSubMenu = (button) => {
        if (window.innerWidth >= this.breakPoint) {
            this.activeElement = button.querySelector('.btn--arrow-down');
            this.activeElement.classList.add('open');

            const subMenu = button.querySelector('.sub-menu').cloneNode(true);
            this.subMenusContainer.innerHTML = '';
            this.subMenusContainer.appendChild(subMenu);
            this.displaySubMenu = true;
        }
    };

    openMobileMenu = (button) => {
        button.closest('.site-header').classList.toggle('open');
    };

    openMobileSubMenu = (button) => {
        if (window.innerWidth < this.breakPoint) {
            button.classList.toggle('open');
            button.closest('li').classList.toggle('open');
        }
        console.log(this.breakPoint);
    };

    footerMenu = (button) => {
        button.classList.toggle('open');
        button.closest('li').classList.toggle('open');
    };
}
